export const isObjectEmpty = (obj: Record<any, any> | null | undefined): boolean => {
  if (obj === null || obj === undefined) {
    return true;
  }
  return !Object.keys(obj).length;
};
